import { useTranslation } from '@frontend/i18n';
import { useViewEventOnCalendar } from './use-view-event-on-calendar';

type UseViewOnCalendarActionProps = {
  eventId: string | undefined;
  eventDate: string | undefined;
};

export const useViewOnCalendarAction = ({ eventId, eventDate }: UseViewOnCalendarActionProps) => {
  const { t } = useTranslation('schedule');
  const { viewOnCalendar } = useViewEventOnCalendar({
    selectedEventIds: [eventId],
    startHour: eventDate,
  });

  return {
    actionProps: {
      label: t('View on Calendar'),
      icon: 'calendar' as const,
      onClick: () => viewOnCalendar(eventId, eventDate),
    },
  };
};
